// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#payment-details-modal {\n  min-width: 300px;\n}\n#payment-details-modal .label {\n  font-size: 14px;\n  text-align: left;\n  color: var(--v-gray_70-base);\n}\n#payment-details-modal .value {\n  font-size: 14px;\n  text-align: left;\n}", ""]);
// Exports
module.exports = exports;
